import React, { useEffect, useState, useRef } from "react";
import AppHeader from "../../components/header";
// The left filter sidebar is archived in ./SidebarFilters (not rendered). These
// two stylesheets used to arrive through its CollapsibleFilter import, and they
// are global: .accordion-* styles the footer, FAQs, hotel details, favourites
// and the list cards. Kept here, at the same position, so the CSS bundle order
// is unchanged.
import "../../components/CustomCheckbox/style.scss";
import "../../components/sections/CollapsibleFilter/style.scss";
import GridView from "../../components/ItemsCardView/ItemsCardGridView";
import ListView from "../../components/ItemsCardView/ItemsCardListView";
import Pagination from "../../components/pagination/Pagination";
// import TextSection from "../../components/sections/BottomTextSetion/BottomTextSetion";
import ListIcon from "../../assets/images/icons/icon-list.svg";
// import QuickFilters from "../../components/sections/QuickFilters";
import ExpediaDark from "../../assets/images/icons/expedia-logo-dark.svg";
import Expedia from "../../assets/images/icons/expedia.svg";
import GeniusImage from "../../assets/images/genius-bird.png";
import Footer from "../../components/footer";
import "./styles.scss";
import {
    getAppConfig,
    getHotels,
    resetChatGPTOffers,
    setActivityIndicator,
    setResponseType,
    setShowRectangular,
    setStatusCodeByGuid,
} from "../../redux/slices/appconfigSlice";
import { useDispatch, useSelector } from "react-redux";
import {
    getSearchFilters,
    setPriceRangeValue,
} from "../../redux/slices/searchFilterSlice";
import AppConfig from "../../helpers/config";
import { getSearchOnlyListingParams } from "../../helpers/common";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getLoginConfig } from "../../redux/slices/loginconfigSlice";
import GridIcon from "../../assets/images/icons/grid-icon.svg";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { resetChatsInStore } from "../../redux/slices/chatBotSlice";
import MapJson from "../../assets/images/lottieViews/map.json";
import BulbJson from "../../assets/images/lottieViews/bulb.json";
import GeniusJson from "../../assets/images/lottieViews/genius.json";
import Lottie from "lottie-react";
import Swal from "sweetalert2";

const Search = () => {
    const url = window.location.href;
    const objUrl = new URL(url);
    const resultRef = React.useRef();
    const { T } = useTranslationCustom();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchTypeRef = useRef("Free");
    const searchParams = new URLSearchParams(objUrl.search);
    const { guid: urlGUID } = useParams();
    const appconfig = useSelector(getAppConfig);
    const loginConfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    const [justArrived, setJustArrived] = useState(true);
    const [page, setPage] = useState(Number(searchParams.get("page")) || 1);
    const isPriceResetRef = useRef(false);


    //   const [dateShouldReset, setDateShouldReset] = useState(false);
    // let HomePackageGUID = '';

    // Confirms the selected package's GUID is in the URL.
    // const isPackageGuid = () => !!appconfig?.packageTypes.find(f => f.guid === urlGUID);

    const handleSearchTypeRef = (type) => {
        searchTypeRef.current = type;
    }

    // Helper function for cross-browser smooth scroll (iOS Safari compatible)
    const scrollToElement = (element) => {
        if (!element) return;

        // Detect iOS Safari
        const isIosSafari = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            !window.MSStream;

        element.scrollIntoView({
            behavior: isIosSafari ? "auto" : "smooth",
            block: "start",
        });
    };

    useEffect(() => {
        getPackagesInitially(); // Fetches packages.
    }, []);

    // Sync page state with URL params
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlPage = Number(params.get("page")) || 1;
        if (urlPage !== page) {
            setPage(urlPage);
        }
    }, [location.search]);

    // Update pagination and data
    useEffect(() => {
        if (!justArrived && appconfig.responseType !== "RealTime") {
            const params = getSearchOnlyListingParams({
                guid: urlGUID,
                page: page,
                searchfilters,
                loginconfig: loginConfig,
                initialSearch: false,
                bigSearch: true,
                SearchType: searchTypeRef.current,
            });

            dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
        } else {
            setJustArrived(false);
            // HomePackageGUID = ''
        }
    }, [location.pathname, location.search]);

    useEffect(() => {
        if (!justArrived && !isPriceResetRef.current) {
            const params = new URLSearchParams(location.search);
            const urlPage = Number(params.get("page"));

            if (urlPage && urlPage === 1) {
                const params = getSearchOnlyListingParams({
                    guid: urlGUID,
                    page: 1,
                    searchfilters,
                    loginconfig: loginConfig,
                    initialSearch: false,
                    bigSearch: true,
                    SearchType: searchTypeRef.current,
                });

                dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
                return;
            }

            navigate(
                "/search/" +
                appconfig.correlationId +
                "/query?page=1&locale=" +
                loginConfig.locale.code +
                "&currency=" +
                loginConfig?.currency?.code
                , { replace: true }
            );
        }
        if (isPriceResetRef.current) {
            isPriceResetRef.current = false;
        }
    }, [searchfilters.defaultPrice]);

    const getPackagesInitially = () => {
        try {
            // "Listing" is passed when arriving from the Chat "Explore All Offers" flow (see handleNavigationToMoreOffers).
            searchTypeRef.current = searchParams.get("searchType") === "Listing" ? "Listing" : "GPT";
            const params = getSearchOnlyListingParams({
                guid: urlGUID,
                page: page,
                searchfilters,
                loginconfig: loginConfig,
                initialSearch: false,
                SearchType: searchTypeRef.current,
            });
            dispatch(getHotels({ params, T, dispatch, handleSearchTypeRef }));
        } catch (error) {
            console.error(error);
            dispatch(setActivityIndicator(false));
            navigate("/", { replace: true });
        }
    };

    // Get other packages for response type RealTime
    useEffect(() => {
        const handleRealTimeResponse = async () => {
            if (appconfig.responseType === "RealTime") {
                if (appconfig.correlationId === appconfig.statusCodeByGuid?.guid && appconfig.statusCodeByGuid?.warnings?.[0]?.code === '204.02') {
                    const result = await Swal.fire({
                        title: T("Common:No_Matches_Under_Budget"),
                        text: appconfig.statusCodeByGuid?.warnings?.[0]?.description || T("Common:No_Matches_Under_Budget_Description"), // 'We couldn’t find any direct flights. Would you like to see results with a stopover?',
                        iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                        showCancelButton: true,
                        confirmButtonText: T("Buttons:Button_Yes"),
                        cancelButtonText: T("Buttons:Button_No"),
                        confirmButtonColor: "var(--green)",
                        cancelButtonColor: "#596C7F",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                    // IF USER CLICKS YES → retry with full app price range
                    if (result.isConfirmed) {
                        isPriceResetRef.current = true;
                        searchTypeRef.current = "Popup";
                        dispatch(setPriceRangeValue({ low: AppConfig.minPrice, high: AppConfig.maxPrice }));
                        dispatch(setStatusCodeByGuid({}));
                    }
                }

                if (appconfig.correlationId === appconfig.statusCodeByGuid?.guid && appconfig.statusCodeByGuid?.warnings?.[0]?.code === '204.03') {
                    await Swal.fire({
                        title: T("Common:Offers_Not_Found"),
                        text: appconfig.statusCodeByGuid?.warnings?.[0]?.description,
                        iconHtml: `
                                <img src=${GeniusImage}
                                     alt="info"
                                     style="width:80px;" />
                              `,
                        showCancelButton: false,
                        confirmButtonText: T("Buttons:Button_Ok"),
                        confirmButtonColor: "var(--green)",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                }

                setTimeout(() => {
                    dispatch(setResponseType(null));
                    navigate(
                        "/search/" +
                        appconfig.correlationId +
                        "/query?page=1&locale=" +
                        loginConfig.locale.code +
                        "&currency=" +
                        loginConfig?.currency?.code
                        , { replace: true }
                    );
                }, 1000);
            }
        };

        handleRealTimeResponse();
    }, [appconfig.responseType]);

    useEffect(() => {
        if (!justArrived) {
            dispatch(resetChatsInStore());
            dispatch(resetChatGPTOffers());

            setTimeout(() => {
                navigate("/");
            }, 100);
        }
    }, [loginConfig.currency, loginConfig.locale]);

    // Plain element rather than an inner component: an inner component is a new
    // type on every render, so React would remount the toggle each time.
    const sortBySection = (
        <div className="list-grid-toggler">
            <a
                onClick={() =>
                    dispatch(setShowRectangular(!appconfig.showRectangular))
                }
            >
                <img
                    src={appconfig.showRectangular ? GridIcon : ListIcon}
                    alt={"list-icon"}
                />
            </a>
        </div>
    );

    return (
        <>
            <div className="main-wrapper search-page">
                <AppHeader />
                <main className="body-wrapper">
                    {/*Quick filters section*/}
                    <div id="quickSearch" className="quick-search-wrapper">
                        <div className="container">
                            {/* Same layout at every width: back to AI on the left, show on
                                map on the right. The desktop filter chips are archived in
                                ./SelectedFilterChips. */}
                            <div className="chips-row w-100 d-flex justify-content-between">
                                {location.pathname.includes("/search/") && (
                                    <div className="my-3 quick-filter-back">
                                        <a
                                            className="animated-back-btn"
                                            onClick={() => navigate('/', { replace: true })}
                                        >
                                            <Lottie
                                                animationData={GeniusJson}
                                                loop={true}
                                                className="genius-animation"
                                            />
                                            <Lottie
                                                animationData={BulbJson}
                                                loop={true}
                                                className="bulb-animation"
                                            />
                                            <span>{T("Buttons:Button_Chat_Ai")}</span>
                                        </a>
                                    </div>
                                )}
                                <a
                                    rel="noopener noreferrer"
                                    className="show-map-link"
                                    onClick={() =>
                                        navigate(`/map/${appconfig?.correlationId}/offers/search/${page}`)
                                    }
                                >
                                    <Lottie
                                        animationData={MapJson}
                                        loop={true}
                                        className="map_animation"
                                    />
                                    {/* <span>{T("Buttons:View_On_Map")}</span> */}
                                    <span>{T("Packages_Detail:Show_On_Map")}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/*End Quick filters section*/}

                    <div id="result" ref={resultRef} className="search-result-wrapper">
                        <div className="container">
                            {/*offers count section*/}
                            <div className="row for-small-screen">
                                <div className="col-12">
                                    <div className="filter-holder">
                                        {/* "Show on map" lives only in .chips-row above now. */}
                                        <div className="hide-on-small-screen count-row">
                                            <div className="top-caption flex-grow-1 align-self-center">
                                                <h5 className="">
                                                    {T("Filters:Filters_Packages_Found", {
                                                        count: appconfig?.metaDataCount || 0,
                                                    })}
                                                </h5>
                                            </div>

                                            <div className="filter-action">
                                                {sortBySection}
                                            </div>
                                        </div>
                                        <div className="filter-mob-wrapper show-on-small-screen">
                                            <div className="flip-animation">
                                                <div className={`flipper auto-flip`}>
                                                    <p className="powered-by-text mt-0">
                                                        {T("Filters:Footer_Powered_By")}{" "}
                                                        <img
                                                            src={loginConfig.darkMode ? Expedia : ExpediaDark}
                                                            alt={"expedia"}
                                                        />
                                                    </p>
                                                    <div className="top-caption flex-grow-1 align-self-center">
                                                        <h5 className="">
                                                            {T("Filters:Filters_Packages_Found", {
                                                                count: appconfig?.metaDataCount || 0,
                                                            })}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>

                                            {sortBySection}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*end section*/}

                            <div className="row">
                                {/* No filter sidebar (archived in ./SidebarFilters). The grid spans
                                    the full row, with ItemsCardGridView adding a column per row so
                                    tiles keep their size. List cards keep their previous width on
                                    xl, centred so they don't stretch; below xl they use the full
                                    row (long cards from 992px, see styles.scss). */}
                                <div className={appconfig.showRectangular ? "col-xl-9 mx-auto" : "col-12"}>
                                    <div className="hotal-item-wrapper grid">
                                        {appconfig.showRectangular ? <ListView openExpediaForAnywhere /> : <GridView openExpediaForAnywhere />}
                                    </div>

                                    <div className="custom-pagination">
                                        <Pagination
                                            _setPage={(page) => {
                                                searchTypeRef.current = "Pagination";
                                                let url = window.location.pathname;
                                                navigate(
                                                    url +
                                                    "?page=" +
                                                    page +
                                                    "&locale=" +
                                                    loginConfig.locale.code +
                                                    "&currency=" +
                                                    loginConfig?.currency?.code
                                                    , { replace: true }
                                                );
                                                setPage(page);
                                                scrollToElement(resultRef?.current);
                                            }}
                                            page={page}
                                        />
                                    </div>

                                    {/*<TextSection/>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Search;
